module.exports = __webpack_public_path__ + "img/artists-carrousel-1.ebe93a5a.png";